export default "__VITE_ASSET__BLvOZAIw__"